import React, { Component } from "react";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import SimpleInput from "../../../modules/SimpleInput";
import { reSignedNumeric } from "../../common/Constants";
import { defaultTableChange } from "../../../modules/custom/customTable";

const DATA_NAME = "poFix";

class PoFixTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pagination: {
        limit: 5,
        page: 1,
      },
    };
  }

  tableColumns = [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, { rowIndex }) => <>{rowIndex + 1}</>,
        setCellHeaderProps: () => ({
          style: {
            width: "40px",
            position: "sticky",
            left: "0px",
            background: "white",
            zIndex: 102,
          },
        }),
        setCellProps: () => ({
          style: {
            width: "40px",
            position: "sticky",
            left: "0px",
            background: "white",
            zIndex: 2,
          },
        }),
      },
    },
    {
      name: "namaVariant",
      label: "Nama Unit",
      options: {
        customBodyRender: (value, { rowIndex }) => {
          const kodeVariant = this.props.data[rowIndex]?.kodeVariant;
          return `${kodeVariant} - ${value}`;
        },
        setCellHeaderProps: () => ({
          style: {
            minWidth: "100px",
            position: "sticky",
            left: "50px",
            background: "white",
            zIndex: 102,
          },
        }),
        setCellProps: () => ({
          style: {
            minWidth: "100px",
            position: "sticky",
            left: "50px",
            background: "white",
            zIndex: 2,
          },
        }),
      },
    },
    {
      name: "namaWarna",
      label: "Warna",
      options: {
        setCellHeaderProps: () => ({
          style: {
            minWidth: "100px",
            position: "sticky",
            left: "180px",
            background: "white",
            zIndex: 102,
          },
        }),
        setCellProps: () => ({
          style: {
            minWidth: "100px",
            position: "sticky",
            left: "180px",
            background: "white",
            zIndex: 2,
          },
        }),
      },
    },
    {
      name: "unitExisting",
      label: "Curr. Stock",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "poRealBefore",
      label: "Qty PO Fix M-1",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "salesOneYear",
      label: "Sales (Last 1 Yr)",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "meanSalesOneYear",
      label: "Sales/Day Yr",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "salesMtd",
      label: "Sales MTD",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "meanSalesMtd",
      label: "Sales/Day MTD",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "proyeksiSalesMtd",
      label: "Proyeksi Sales MTD",
      options: {
        customBodyRender: (val, { rowIndex }) => (
          <SimpleInput
            id="input_text_proyeksi_sales_mtd"
            name="proyeksiSalesMtd"
            containerclassname="margin-bottom-none"
            value={val}
            onChange={({ target }) => {
              if (reSignedNumeric.test(target.value)) {
                this.props.onValueChange(
                  DATA_NAME,
                  rowIndex,
                  target.name,
                  target.value,
                );
              }
            }}
          />
        ),
        setCellProps: () => ({
          style: {
            minWidth: "150px",
          },
        }),
      },
    },
    {
      name: "currentStockM2",
      label: "Curr. Stock M+2",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "proyeksiSalesM2",
      label: "Proyeksi Sales M+2",
      options: {
        customBodyRender: (val, { rowIndex }) => (
          <SimpleInput
            id="input_text_proyeksi_sales_m"
            name="proyeksiSalesM2"
            containerclassname="margin-bottom-none"
            value={val}
            onChange={({ target }) => {
              if (reSignedNumeric.test(target.value)) {
                this.props.onValueChange(
                  DATA_NAME,
                  rowIndex,
                  target.name,
                  target.value,
                );
              }
            }}
          />
        ),
        setCellProps: () => ({
          style: {
            minWidth: "150px",
          },
        }),
      },
    },
    {
      name: "stockDays",
      label: "Stok Days",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "acuanStock",
      label: "Acuan",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "delta",
      label: "Delta",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "qtyPoRecommended",
      label: "Qty PO Rec.",
      options: {
        setCellProps: () => ({
          style: {
            minWidth: "100px",
          },
        }),
      },
    },
    {
      name: "qtyPoReal",
      label: "Qty PO Real",
      options: {
        customBodyRender: (val, { rowIndex }) => (
          <SimpleInput
            id="input_text_qty_po_real"
            name="qtyPoReal"
            containerclassname="margin-bottom-none"
            value={val}
            onChange={({ target }) => {
              if (reSignedNumeric.test(target.value)) {
                this.props.onValueChange(
                  DATA_NAME,
                  rowIndex,
                  target.name,
                  target.value,
                );
              }
            }}
          />
        ),
        setCellProps: () => ({
          style: {
            minWidth: "150px",
          },
        }),
      },
    },
  ];

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  render() {
    return (
      <SimpleDataTable
        key={`${this.props.data?.length}-${this.state.pagination.page}`}
        data={this.props.data}
        columns={this.tableColumns}
        toCount={this.props.data?.length}
        rowsPerPage={this.state.pagination.limit}
        page={this.state.pagination.page - 1}
        options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
      />
    );
  }
}

export default PoFixTable;
